import { DataBean } from "../DataBean";

export class QualityInspectionSpecialGarment extends DataBean {

  public async getQualityInspectionSpecialGarmentCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionSpecialGarmentCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteQualityInspectionSpecialGarment(idqualityinspectionspecialgarment: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionSpecialGarment_Number", [idqualityinspectionspecialgarment]);
  }

  public async updateQualityInspectionSpecialGarment(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionSpecialGarment_updateQualityInspectionSpecialGarment_com.orange.finance.processcontract.bean.QualityInspectionSpecialGarment",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionSpecialGarment",
        },
      ]
    );
  }
}
